<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a><a id="ch00_fm03_title"></a>Religion and the Creation of Race and Ethnicity</h1>
<p class="subtitle"><em>An Introduction</em></p>
<p class="authorcenter"><span class="small"><strong>EDITED BY</strong></span><br/><em>Craig R. Prentiss</em></p>
<p class="nimage"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_title.vue?47a4f982